import { Location , DatePipe, DecimalPipe} from '@angular/common';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Device } from '@capacitor/device';
import { MenuController, AlertController,Platform, IonModal } from '@ionic/angular';
import { take } from 'rxjs';
import printJs from 'print-js'

import { ApiService } from './Services/Apis/api.service';
import { DataService } from './Services/Data/data.service';


declare var $: any;

declare var dayjs: any;
declare var LottiePlayer: any;



// import {} from '@types/googlemaps';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

count = 0;
currentRoute = '';
// variable store event
deferredPrompt : any;
hidebutton = true;
showopenaspwa = true;

prefersDark: any;
togglebutton: any;
showbackbutton = false;
backdropDismiss = false

userviewsbool = false;
riderviewsbool = false;
vendorviewsbool = false;
darkmodebool = true;

newWindow: any = navigator;
cart = 0;
user: any;
isModalOpen = false;
position: any;

autocomplete: any;
address1Field : any;

 priceper_km = 0;
 deliveryfee = 0;
 total = 0;
 cartdetailsfull: any;
  cachecount = 0;
  showloactionspinner = false;
  adminlocationbool = false;
  requestlocation: any;

   analytics = {
    message : "message",
    who : 'Rider/User',
    who_id : "",
    page : 'login page',
    action : 'login',
    type : 'install'
  }

  deliverytypeobject = {
    type : '',
    datetime : '',
    message : ''
  }

  pickuptypeobject = {
    now : 'light',
    later : 'light'
  }

  km: any = 0;

  checked = 'custom';
  dateselected: any;
  isOpen = false;
  now: any;
  timediffernece = {
    now : false,
    later : false,
    diff: 0,
    diffstring: '',
    format: 'mins',
     type :'',
     datetime: '',
     message: '',
     number : '',
     pickupfee : 0

  }
  tallys = "";
  loopcounter = 0;
 @ViewChild('location_box') addresstext: any;
 type = '';
 vendormessage = '';
 vendor_percentage = 0;
 itemfee = 0;
 oldcount = 0;
 newcartcount = 0;
 button_data: any = {};
 canDismiss = true;
 someJSONdata: any;
 who: any



 //

 subscription: any;
 isopenDate: boolean = false;

  constructor(private router: Router, private alertController: AlertController, private datePipe: DatePipe, private ngZone: NgZone, private platform: Platform, public menuCtrl: MenuController, private location: Location, private share: DataService, private api: ApiService, private route: ActivatedRoute, private decimalPipe: DecimalPipe) {

  // console.log = function() {}

  this.reloadPWA()



   this.subscription =  this.share.getAlertButton.subscribe((data: any) => {

     console.log(data);
     
     if(data?.status == true ) {

      this.button_data = data;

      if(this.button_data?.type == 'order') {

        this.canDismiss = false;

        this.button_data.data.forEach((element: any, i: number) => {
          
          if(i == 0) {
            this.tallys =  element?.tally
          }
          else {
            this.tallys  =   this.tallys  + ","+element?.tally
          }
          
        });
      }


      if(data?.status == true && data?.type == 'orders_page' ) {
  
        this.printDocumentV2(false, false, data?.value)
  
        return
      }
  

      $("#open-modal").click();

     }

  });


  this.share.getShareObjectMsg.subscribe((response: any) => { 

     console.log(response);
    if(response.type == 'searchfilter') {
      this.isopenDate = true
    }

  });
  

  }

  ngOnInit(): void {

    
    this.checkPlatform()
    // this.preloadTheme()
    this.loadAppnew()
    this.menuitems()


    var who: any = localStorage.getItem('who')
    this.who = JSON.parse(who);


  }






  ngAfterViewInit() {

    this.pwaMessage();

  }

  toogleMenu(){
    this.menuCtrl.toggle();
  }

  goBack() {

    this.location.back();

  }



  




 focusClick() {
  console.log('focuesd')

  setTimeout(() => {
    // this.initAutocomplete()
  }, 500);
 }





  logOut() {
    window.location.href = "";

    this.themeLogout();
  }



  themeLogout() {

     // check if username is set dont delete it .. get it before below runs then at the bottom save iot back if it exist;
    var username = localStorage.getItem('username');
    var dvid = localStorage.getItem('dvid');

    var notification_count = (localStorage.getItem('notification_count') as any);
    var notification = localStorage.getItem('notification');

   var oisstandalone = localStorage.getItem('oisstandalone');
   var pickupanimation = localStorage.getItem('pickupanimation');

   var installdeniedcount =  localStorage.getItem('installdeniedcount');
   var randset =  localStorage.getItem('randset');
   var sound =  localStorage.getItem('sound');

    if(localStorage.getItem('theme')) {
      var theme = localStorage.getItem('theme');

       if(theme == 'dark') {

        localStorage.clear();

        document.body.classList.add('dark');
        // this.darkmodebool = false;
        localStorage.setItem('theme','dark');

       }
       else {

        localStorage.clear();

        document.body.classList.add('light');
        localStorage.setItem('theme','light');

       }
    }
    else {

      localStorage.clear();
      document.body.classList.add('dark');
      localStorage.setItem('theme','dark');

    }
    

    // save username u got at the top after code above had run

    if(username) {
      localStorage.setItem('username',username);
    }

    if(notification_count) {
      localStorage.setItem('notification_count',notification_count+"");
    }

    if(notification) {
      localStorage.setItem('notification',notification);
    }

    if(oisstandalone) {
      localStorage.setItem('oisstandalone',oisstandalone);
    }
    if(pickupanimation) {
      localStorage.setItem('pickupanimation',pickupanimation);
    }

    if(installdeniedcount) {
      localStorage.setItem('installdeniedcount',installdeniedcount);
    }

    if(randset) {
      localStorage.setItem('randset',randset);
    }
    if(sound) {
      localStorage.setItem('sound',sound);
    }






  }


  menuitems() {

    $( ".menuitem" ).click((event: any) =>{
      // console.log(event.currentTarget.id)
      // alert( "Handler for .click() called." );
      $( ".menuitem"+' ion-label' ).removeClass('menuitemcolor')
      $( "#"+event.currentTarget.id+' ion-label' ).addClass('menuitemcolor')

      this.toogleMenu()
    });
  }


  subscribeToUser() {

     console.log("called get user")
    if(localStorage.getItem('who')) {

      var who: any = localStorage.getItem('who');
      who = JSON.parse(who);

      if(who?.user == 'vendor') {

        this.user = who;
        this.share.setShareObjectMsg(who)

      }

      if(who?.user == 'admin') {

        this.api.getRider().then((data: any) => {

         console.log(data)

          if(data.user){

           this.user = data.user;
           this.share.setShareObjectMsg(data)

           }
          else {
           this.router.navigateByUrl('login').then(data => {
             // localStorage.clear()
             localStorage.removeItem('k')
           })
          }

        })
     }



    }
    else {

      this.router.navigateByUrl('login').then(data => {
        localStorage.removeItem('k')
      })

    }


    // this.share.getShareObjectMsg.subscribe(data => {
    //   console.log(data)

    // })
  }





  setToStorage() {

    var storage = this.share.getStoraage();

     if(storage != null) {


     }
      else {

        this.router.navigateByUrl('login').then(data => {

          console.log(storage)
        })

      }
  }



  // createStorageDEtails() {

  //   var storage = this.share.getStoraage();

  //   if(storage == null) {

  //     localStorage.setItem('booking','{}');
  //   }

  // }





  reloadPWA() {


     this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
          // Show progress spinner or progress bar
          // console.log('Route change detected');
          this.showbackbutton = false;
          this.share.setHamburgerMenutMsg(this.showbackbutton)
          this.InterceptInstallPrompt()
      }

      if (event instanceof NavigationEnd) {

        // setTimeout(() => {
        //   this.InterceptInstallPrompt()
        // }, 5000);

        this.currentRoute = event.url;

        // prevent show of menu in login page
        if(this.currentRoute.includes('login')) {
          this.menuCtrl.enable(false);
          //  this.createStorageDEtails();
          // alert('checkout');
        }


         // allow toolbar only in userview
        if(this.currentRoute.includes('user/tabs/')) {

          this.userviewsbool = true;
          // alert('checkout');
        }

        // allow toolbar only in riderview
        if(this.currentRoute.includes('rider/tabs/')) {

          this.riderviewsbool = true;
          // alert('checkout');
        }

        // allow toolbar only in vendorview
        if(this.currentRoute.includes('vendor/tabs/')) {

          this.vendorviewsbool = true;
          // alert('checkout');
        }




        // hide back button wheere necesarry;

       if(!this.currentRoute.includes('/tabs/home')) {

          console.log('yes')
          this.showbackbutton = true;
          this.share.setHamburgerMenutMsg(this.showbackbutton)
          // alert('checkout');
        }


        if(this.currentRoute == '') {


          if (window.matchMedia('(display-mode: standalone)').matches) {
            // alert('display-mode is standalone');

            // window.addEventListener("visibilitychange", function () {
            //   console.log("Visibility changed");
            //   if (document.visibilityState === "visible") {
            //     console.log("APP resumed");
            //     window.location.reload();
            //   }
            // });


              if (document.visibilityState === "visible") {
                console.log("APP resumed");

                // alert('display-mode is standalone');

                window.location.reload();

                window.stop();

              }



          }
          else {

            if(this.count < 1) {

              // window.addEventListener("visibilitychange", function () {
              //   console.log("Visibility changed");
              //   if (document.visibilityState === "visible") {
              //     console.log("APP resumed");
              //     window.location.reload();
              //   }
              // });


                if (document.visibilityState === "visible") {
                  console.log("APP resumed");

                  // alert('display-mode is not standalone');

                  window.location.reload();
                  window.stop();


                }


            }
            this.count = 1
          }



        }



        if(!this.currentRoute.includes('signup') && !this.currentRoute.includes('reset') && !this.currentRoute.includes('login') && !this.currentRoute.includes('vendor/login')) {
          console.log("I got here 2")
          // this.setToStorage()
          this.subscribeToUser();
        }


         if(window.location.href.includes('login') || window.location.href.includes('vendor/login')){
          // console.log(window.location.href)
          this.clearServiceWrokerCache()
         }



         if(window.location.href.includes('vendor/login')) {

          this.presentAlert()

         }
      }


      if (event instanceof NavigationError) {
           // Hide progress spinner or progress bar

          // Present error to user
          // console.log(event.error);
      }
  });


  }




  async presentAlert() {

    const alert = await this.alertController.create({
      header: 'Hi, you are heading to vendor section!🔔',
      message: 'Do you want to login as a vendor or a user?',
      buttons: [
        {
          text: 'User',
          role: 'cancel',
          handler: () => {

           var who =  localStorage.getItem('who');
           if(who) {
            localStorage.removeItem('who');
           }
            window.location.href = 'login'

            console.log("cancelled")
          },
        },
        {
          text: 'Vendor',
          role: 'confirm',
          handler: () => {

            var who =  localStorage.getItem('who');
            if(who) {
             localStorage.removeItem('who');
            }
            this.share.setToastMsg({status:"medium" , message: "Alright, login as a vendor below", duration: 3000,position:'top'})

            // window.location.href = 'vendor/login';

            console.log("Allow");

          },
        },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    // this.roleMessage = `Dismissed with role: ${role}`;
  }





  async presentAlert3() {

    const alert = await this.alertController.create({
      header: 'Yoo!, headsup!🔔',
      message: 'Kindly use a mobile device. Thanks',
      backdropDismiss: false,
      buttons: [
        // {
        //   text: 'User',
        //   role: 'cancel',
        //   handler: () => {

        //    var who =  localStorage.getItem('who');
        //    if(who) {
        //     localStorage.removeItem('who');
        //    }
        //     window.location.href = 'login'

        //     console.log("cancelled")
        //   },
        // },
        // {
        //   text: 'Continue',
        //   role: 'confirm',
        //   handler: () => {
        //     console.log("installed");
        //     window.location.reload();
        //   },
        // },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    // this.roleMessage = `Dismissed with role: ${role}`;
  }



  async presentAlert2() {

    const alert = await this.alertController.create({
      header: 'App installed on your device!🔔',
      message: 'Please search Peral De Food on your device or continue using this web version',
      buttons: [
        // {
        //   text: 'User',
        //   role: 'cancel',
        //   handler: () => {

        //    var who =  localStorage.getItem('who');
        //    if(who) {
        //     localStorage.removeItem('who');
        //    }
        //     window.location.href = 'login'

        //     console.log("cancelled")
        //   },
        // },
        {
          text: 'Continue',
          role: 'confirm',
          handler: () => {
            console.log("installed");
            window.location.reload();
          },
        },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    // this.roleMessage = `Dismissed with role: ${role}`;
  }


  pwaMessage() {
    this.share.getPWAMsg.subscribe((data: any) => {

      console.log("pwa message appcomponent")

      console.log(data)
      if(data.message == 'install') {
        console.log("pwa apcomponernt called")

        this.clickPrompt();

      }
    })
  }


  clearServiceWrokerCache() {
    console.log("service workwr cacvhe")


    if (navigator.onLine) {
      // alert('online');

      if ('serviceWorker' in navigator) {
        caches.keys().then((cacheNames) => {

          if(cacheNames.length > 1) {

            cacheNames.forEach((cacheName) =>{
              caches.delete(cacheName);
              console.log("service workwr cacvhe cleared:"+cacheName)

            });


            // alert('cleared cache count: '+cacheNames.length)

                // setTimeout(() => {
                //   window.location.reload()
                // }, 2000);

                this.cachecount = cacheNames.length;

          }

        });
      }


    } else {

      alert("You are offline");
    }


  }

  InterceptInstallPrompt() {




// get button with id
// const install_button: any = document.getElementById('installbutton');

// if the app can be installed emit beforeinstallprompt
window.addEventListener('beforeinstallprompt', (e:any) => {
  // this event does not fire if the application is already installed
  // then your button still hidden ;)

  this.share.setPWAMsg({
    'page': 'pwa',
    'message': 'androidinstallable'

  })

  console.log('fired before install')
  // show button with display:block;
  this.hidebutton = false;
  this.showopenaspwa = false;
  // prevent default event
  e.preventDefault();

  // store install avaliable event
  this.deferredPrompt = e;


});





// // if are standalone android OR safari
// if (window.matchMedia('(display-mode: standalone)').matches || this.newWindow.standalone === true) {
//   // hidden the button
//   this.hidebutton = true;
// }

// do action when finished install
window.addEventListener('appinstalled', (e:any) => {
  console.log("success app install!");
  this.showopenaspwa = true;
  this.hidebutton = true;
  // this.checkSendDeviceIID('install')

  this.presentAlert2();

  // alert('app installed successfully')
});


  }



  clickPrompt() {

      // wait for click install button by user

    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        // user accept the prompt
        console.log('User accepted the prompt');
        // alert('user accepted')
        // lets hidden button
      } else {
        console.log('User dismissed the prompt');
        alert('user denied installation, please install DoorBox')
      }
      this.deferredPrompt = null;
    });


  }







  checkPlatform() {

 this.platform.ready().then((data) => {

  console.log(data)
if (this.platform.is('android')) {
        console.log('android');
        // alert('android')
        if (this.platform.is('mobileweb')) {
          console.log("mobileweb")
        }

        if (this.platform.is('mobile')) {
          console.log("mobile")
        }

        if (this.platform.is('pwa')) {
          console.log("pwa")
        }

        if (this.platform.is('desktop')) {
          console.log("desktop")
        }

        if (this.platform.is('hybrid')) {

          console.log("hybrid")
        }


        // if are standalone android OR safari
if (window.matchMedia('(display-mode: standalone)').matches) {
  // hidden the button
  console.log('standalone, android');
  this.showopenaspwa = false;

}else {

  // this.showopenaspwa = true;
  console.log('not standalone, android');
  // this.InterceptInstallPrompt();

}


   } else if (this.platform.is('ios')) {

                // if are standalone android OR safari
if (this.newWindow.standalone === false) {
  // hidden the button
  // this.hidebutton = true;
  this.showopenaspwa = false;
  this.share.setPWAMsg({
    'page': 'pwa',
    'message': 'iosinstallable'

  })

  // alert('Not a standalone ios app, please use safari then add the app to homescreen, if you havent')
}else {

  localStorage.setItem('oisstandalone', 'true');
  this.showopenaspwa = false;

}

        // alert('alert ios')
   }

   else if (this.platform.is('desktop')) {

    this.presentAlert3();

  }


   else {
        //fallback to browser APIs or
        // alert('alert web')
console.log('The platform is not supported, web');

              // if are standalone android OR safari
if (window.matchMedia('(display-mode: standalone)').matches) {
  // hidden the button
  console.log('standalone, web');

  this.showopenaspwa = false;

}else {
  console.log('not standalone, web');
  // this.showopenaspwa = true;
  // this.InterceptInstallPrompt();

}


          }

      })

  }







  Clickthemenew() {

    if(localStorage.getItem('theme')) {
      var theme = localStorage.getItem('theme');

       if(theme == 'dark') {

        document.body.classList.remove('dark');
        this.darkmodebool = false;
        localStorage.setItem('theme','light');

       }
       else {

        this.darkmodebool = true;
        document.body.classList.add('dark');
        localStorage.setItem('theme','dark');

       }
    }
    else {

      this.darkmodebool = true;
      document.body.classList.add('dark');
      localStorage.setItem('theme','dark');

    }

  }


  closeModal() {

    this.isModalOpen = false;

     if(this.currentRoute.includes("checkout")) {

      setTimeout(() => {
        window.location.href = "/user/tabs/vendors";
      }, 1000);

     }

  }






  preloadTheme() {

      // Query for the toggle that is used to change between themes
 var togglebutton: any = document.querySelector('#themeToggle');


// Listen for the toggle check/uncheck to toggle the dark class on the <body>
 togglebutton?.addEventListener('ionChange', (ev: any) => {
  document.body.classList.toggle('dark', ev.detail.checked);

   if(ev.detail.checked == true) {
    localStorage.setItem('theme','dark');
   }
   else {
    localStorage.setItem('theme','light');
   }
  console.log(ev.detail.checked)

});

// this.checkToggle(prefersDark.matches)
// console.log(prefersDark)
 const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
 console.log(prefersDark)
// Listen for changes to the prefers-color-scheme media query
prefersDark.addEventListener("onchange", (e: any) => {
  console.log(e)

  // get the new prefrences for dark if true means user toghled for dark if false use toglled for no dark.. that is user removed class dark
  this.checkToggle(togglebutton, e.matches)
});

// default on app load
this.loadApp(togglebutton)

  }


  loadAppnew() {

    if(localStorage.getItem('theme')) {
      var theme = localStorage.getItem('theme');

       if(theme == 'dark') {
        document.body.classList.add('dark');
        this.darkmodebool = true;

       }
       else {
        this.darkmodebool = false;
        document.body.classList.remove('dark');


       }
    }
    else {
      document.body.classList.add('dark');
      this.darkmodebool = true;

    }

  // if(!document.body.classList.contains('dark')) {
  //   document.body.classList.add('dark');
  //   // on load set the deafult scheme to dark and toggle the button to true
  // this.checkToggle(button, true);
  // }

}




// Called when the app loads
 loadApp(button: any) {

    if(localStorage.getItem('theme')) {
      var theme = localStorage.getItem('theme');

       if(theme == 'dark') {
        document.body.classList.add('dark');
        this.darkmodebool = true;
        this.checkToggle(button, true);
       }
       else {
        this.darkmodebool = false;
        document.body.classList.remove('dark');
        this.checkToggle(button, false);

       }
    }
    else {
      document.body.classList.add('dark');
      this.darkmodebool = true;
      this.checkToggle(button, true);
    }

}

// set the toggle button to the slected state , true for dark mode false or light mode
 checkToggle(button: any, shouldCheck: any) {

  button.checked = shouldCheck;
}





presentPopover() {

  //  console.log(event.target.checked)
  //  if(event.target.checked == true) {
  //   this.isOpen = true;
  //   this.pickerbool = true;
  //   return
  //  }
 
   this.isOpen = true;

  //  this.dateselected  = "Shedule Order";
  //  this.isOpen = false;

}



selectedDate(event: any) {


var dateFromIonDatetime: any = this.datePipe.transform(event.detail.value, 'yyyy-MM-dd HH:mm:ss')

 console.log(dateFromIonDatetime)

//  const date2 = dayjs(this.dateselected)
this.share.getShareObjectMsg.pipe(
  take(1),
).subscribe((data: any) => {

      if(data.type == 'searchfilter') {
        this.share.setShareObjectMsg({type:'searchfilter',date:dateFromIonDatetime})
      }else {
        this.share.setShareObjectMsg({type:'search',date:dateFromIonDatetime, to: 'home'})
      }
      this.isopenDate = false;

})


}



//////////////////

alertButtonClick(modal: IonModal, status: boolean, where: string): void {

   if(where == 'others') {

    this.share.setAlertMsg({status: status});
    if(this.button_data?.type != 'order' && this.button_data?.type != 'change') {
      modal.dismiss();
      this.canDismiss =  true;
    }
    else {
    
    }
   
   }
   else {

    modal.dismiss();
    this.canDismiss =  true;
    // modal.backdropDismiss = false; 

   }
  // this.subscription.unsubscribe();

  
}

presentControlDate() {
 this.isopenDate = true;
 this.share.setShareObjectMsg({type: 'search', to: 'order'})
}

printDocument(modal: any, status: any, data: any) {

  this.someJSONdata = [
    {
       name: 'John Doe',
       email: 'john@doe.com',
       phone: '111-111-1111'
    },
    {
       name: 'Barry Allen',
       email: 'barry@flash.com',
       phone: '222-222-2222'
    },
    {
       name: 'Cool Dude',
       email: 'cool@dude.com',
       phone: '333-333-3333'
    }
 ]


 $("#printme" ).append( `<div id="printbox">

 <div style="margin-bottom: 5px" class="line">
 <label style="display: block" id="businessname" class="businessname">Peral De Food</label>

 </div>
 <div  class="line">
 <label class="floatleft" > Order ID: </label>
 
 <label class="floatright" id="name"> </label>
 
 </div>


 <div class="line" >
 <label class="floatleft" > Amount </label>
 
<label style="font-weight: bold; " id="amount"  class="floatright">  </label>
 </div>

 <div class="line">
 <label  class="floatleft"> Created On: </label>
 
 <label class="floatright" style="font-weight: bold; " id="created_at"> 17/10/2024</label>
 
 </div>

 <div class="line">

 <p > <label > Tally: <label  style="font-weight: bold; margin-left:25px; padding-bottm: 10px" id="tally" > </label> </label></p>
 
 </div>

 <div class="line" id="products">
 <label  class="floatleft"> Items:    </label>
 
 <label class="floatright" id="items"> </label>
 <label class="floatright" id="packs"> </label>
 </div>

 <div class="line" id="packs">
 <label  class="floatleft"> Packs:      </label>
 <label class="floatright" id="pack" style="font-weight: bold; margin-left:25px"> </label>
 </div>
 
 <div class="line" id="paymenttype">
 <label  class="floatleft">Payment :      </label>
 <label class="floatright" id="paymentt"> </label>
 </div>


 <div class="line">
 <label  class="floatleft"> Creator : </label>
 
 <label class="floatright" id="created_by"> Temilade</label>
 
 </div>


 
 <div>

 <label style="display: block"> <span style="font-style: italic" class="mealmessage"> Enjoy your meal </span> <span>💚 </span></label> 

 </div>

 
 </div>` );
 

 $( "#businessname" ).html(this.who ? this.who?.location : 'PERAL DE FOOD');
 $( "#name" ).html( data?.id?.length > 15 ?  data?.id.slice(0,13)+"..." : data?.id );
 $( "#amount" ).html("NGN"+ this.decimalPipe.transform(data?.amount, '.1'));
 $( "#tally" ).html(data?.tally);  
 $( "#created_by" ).html(data?.creator?.length > 15 ?  data?.creator.slice(0,15)+"..." : data?.creator);
 $( "#created_at" ).html(this.datePipe.transform(data?.created_at, 'dd/MM/yyyy - hh:mm:ss a', 'GMT'))
 $( "#paymentt" ).html(data?.payment_type);


  if(data?.products?.length > 0) {

   var hasunderscore  = data?.products.filter((item: any) => item?.name.includes("_"));
   var nounderscore: any[]  = [...data?.products];

    if(hasunderscore?.length > 0) {

        nounderscore?.forEach((element: any) => {
         
          element.value = 0
          hasunderscore.forEach((elm: any, i: any) => {
            
            if(element?.name.toLowerCase() == elm?.name.toLowerCase().split("_")[0]) {
              element.value = element.value + (elm.amount*elm.qty)+(element.amount*element.qty);
              element.modified = true;

              var index = nounderscore.findIndex((elemmm) => elemmm.id == elm?.id );

              if(index > -1) {
                nounderscore.splice(index, 1);
              }
        

            }
        
        
          });
  
      
        });


     

    }
    else {
      // nounderscore = data?.products;
    }

     nounderscore.forEach((element: any) => {
  
      if(element?.modified && element?.modified == true) {
        $( `<label>  </label>` ).css("display", "block").attr({

          id: element.id,   
      
        }).html(element.name+"(NGN"+(this.decimalPipe.transform(element.value, '.0'))+")").appendTo( "#items" );
  
      }
      else {

        $( `<label>  </label>` ).css("display", "block").attr({

          id: element.id,   
      
        }).html(element.name + "("+element.qty+")"+"("+element.amount+") - "+"(NGN"+this.decimalPipe.transform(element.qty*element.amount, '.0')+")").appendTo( "#items" );

      }
  
    });

    console.log(hasunderscore)
    console.log(nounderscore)

    $("#pack" ).html(data?.count);
  }
  else {
    $("#products" ).remove();
    $("#packs" ).remove();
  }

 printJs({ printable: 'printme', type: 'html' ,
 style: '.line{ border-bottom: 2px solid rgb(239, 239, 239); margin-bottom: 15px; margin-top: 15px; } .line label {font-size: 40px;} .mealmessage {font-size: 40px} #amount {font-size: 50px !important; font-weight: bold} .businessname {font-size: 80px; font-weight: bold}  .floatright { margin-left:50px}',
 
 maxWidth: 800,   scanStyles: false})
//  font_size: "30pt"

 $( "#printbox" ).remove();
//  printJs({printable: this.someJSONdata, properties: ['name', 'email', 'phone'], type: 'json'});
this.canDismiss =  true;
modal.dismiss();

}

closePreview(modal: any){
  this.canDismiss =  true;
  modal.dismiss();
}


                 //  set your counter to 1

 myLoop( data: any, modal: any) {  


//   console.log(data);        //  create a loop function
//  var timeout = setTimeout( () => {   //  call a 3s setTimeout when the loop is called
//     console.log('hello');   //  your code here
//     this.loopcounter++;                    //  increment the counter
//     // if (i > data?.length) {           //  if the counter < 10, call the loop function
//     //     //  your code here
//     //   clearInterval(timeout)//  ..  again which will trigger another 
//     //   // this.canDismiss =  true;
//     //   // modal.dismiss();
//     //   console.log('loop finished');   //  if the counter > 10, stop the loop
//     // }   
//     console.log(data[this.loopcounter]);                    //  ..  setTimeout()
//   }, 2000)





}




 printLoop( data: any, modal: any) {

  for (var i = 0; i < data?.length; i++) {
    ((i) => {
     var it = setTimeout(() => { 
      console.log(data[i]);  // code here

     try {
      this.processPrint(data[i], modal);
     } catch (error) {
      
      console.log(error);
     }
      if(i == data?.length - 1) {
        clearInterval(it )
        console.log("done");
        this.canDismiss =  true;
        modal.dismiss();
      }
    }, (this.who?.printertype == "1" ? 1000 : 20) * i);
    })(i);
  }
}


 
          //  set your counter to 1




printDocumentV2(modal: any, status: any, data: any) {

  this.printLoop(data, modal);
  
}

 
processPrint(data: any, modal: any) {


  
  let headingName = ` ^XA ^FO 130, 30 ^A0, 35 ^FD ${this.who ? this.who?.location : 'PERAL DE FOOD'} ^FS`;
  let address = `^FO 50, 70 ^A1, 20 ^FD 20, Iwaya Road, Yaba, Lagos : 08037445015 ^FS`;
  let firstLine = `
  ^FO40,100  ^GB 20,2,2 ^FS
  ^FO70,100 ^GB 20,2,2 ^FS
  ^FO100,100 ^GB 20,2,2 ^FS
  ^FO130,100 ^GB 20,2,2 ^FS
  ^FO160,100  ^GB 20,2,2 ^FS
  
  ^FO190,100  ^GB 20,2,2 ^FS
  ^FO220,100  ^GB 20,2,2 ^FS
  ^FO250,100  ^GB 20,2,2 ^FS
  ^FO280,100  ^GB 20,2,2 ^FS
  ^FO310,100  ^GB 20,2,2 ^FS
  ^FO340,100  ^GB 20,2,2 ^FS
  
  ^FO370,100  ^GB 20,2,2 ^FS
  ^FO400,100  ^GB 20,2,2 ^FS
  ^FO430,100  ^GB 20,2,2 ^FS
  ^FO460,100  ^GB 20,2,2 ^FS
  ^FO490,100  ^GB 20,2,2 ^FS
   `;

  let seconLine = `
  ^FO40,420  ^GB 20,2,2 ^FS
  ^FO70,420  ^GB 20,2,2 ^FS
  ^FO100,420  ^GB 20,2,2 ^FS
  ^FO130,420  ^GB 20,2,2 ^FS
  ^FO160,420  ^GB 20,2,2 ^FS
  
  ^FO190,420  ^GB 20,2,2 ^FS
  ^FO220,420  ^GB 20,2,2 ^FS
  ^FO250,420  ^GB 20,2,2 ^FS
  ^FO280,420  ^GB 20,2,2 ^FS
  ^FO310,420  ^GB 20,2,2 ^FS
  ^FO340,420  ^GB 20,2,2 ^FS
  
  ^FO370,420  ^GB 20,2,2 ^FS
  ^FO400,420  ^GB 20,2,2 ^FS
  ^FO430,420  ^GB 20,2,2 ^FS
  ^FO460,420  ^GB 20,2,2 ^FS
  ^FO490,420  ^GB 20,2,2 ^FS
  `;


  let thirdLine = `
  ^FO40,480  ^GB 20,2,2 ^FS
^FO70,480 ^GB 20,2,2 ^FS
^FO100,480 ^GB 20,2,2 ^FS
^FO130,480  ^GB 20,2,2 ^FS
^FO160,480 ^GB 20,2,2 ^FS

^FO190,480  ^GB 20,2,2 ^FS
^FO220,480  ^GB 20,2,2 ^FS
^FO250,480  ^GB 20,2,2 ^FS
^FO280,480  ^GB 20,2,2 ^FS
^FO310,480  ^GB 20,2,2 ^FS
^FO340,480  ^GB 20,2,2 ^FS

^FO370,480  ^GB 20,2,2 ^FS
^FO400,480 ^GB 20,2,2 ^FS
^FO430,480  ^GB 20,2,2 ^FS
^FO460,480  ^GB 20,2,2 ^FS
^FO490,480  ^GB 20,2,2 ^FS
`;
  let fourthLine = `
  ^FO40,540  ^GB 20,2,2 ^FS
  ^FO70,540  ^GB 20,2,2 ^FS
  ^FO100,540  ^GB 20,2,2 ^FS
  ^FO130,540  ^GB 20,2,2 ^FS
  ^FO160,540 ^GB 20,2,2 ^FS
  
  ^FO190,540  ^GB 20,2,2 ^FS
  ^FO220,540  ^GB 20,2,2 ^FS
  ^FO250,540  ^GB 20,2,2 ^FS
  ^FO280,540  ^GB 20,2,2 ^FS
  ^FO310,540  ^GB 20,2,2 ^FS
  ^FO340,540  ^GB 20,2,2 ^FS
  
  ^FO370,540  ^GB 20,2,2 ^FS
  ^FO400,540 ^GB 20,2,2 ^FS
  ^FO430,540  ^GB 20,2,2 ^FS
  ^FO460,540  ^GB 20,2,2 ^FS
  ^FO490,540  ^GB 20,2,2 ^FS
  `;

  let fifthLine = `
  ^FO40,680  ^GB 20,2,2 ^FS
  ^FO70,680 ^GB 20,2,2 ^FS
  ^FO100,680 ^GB 20,2,2 ^FS
  ^FO130,680 ^GB 20,2,2 ^FS
  ^FO160,680 ^GB 20,2,2 ^FS
  
  ^FO190,680  ^GB 20,2,2 ^FS
  ^FO220,680  ^GB 20,2,2 ^FS
  ^FO250,680  ^GB 20,2,2 ^FS
  ^FO280,680  ^GB 20,2,2 ^FS
  ^FO310,680  ^GB 20,2,2 ^FS
  ^FO340,680  ^GB 20,2,2 ^FS
  
  ^FO370,680  ^GB 20,2,2 ^FS
  ^FO400,680 ^GB 20,2,2 ^FS
  ^FO430,680  ^GB 20,2,2 ^FS
  ^FO460,680  ^GB 20,2,2 ^FS
  ^FO490,680  ^GB 20,2,2 ^FS
`;


  // order id
  let orderId = `^FO 20, 120 ^A1, 25 ^FD ORDER ID: ^FS`;
  let orderIdValue = `^FO 300, 120 ^A1, 25 ^FD ${data?.id?.length > 11 ?  data?.id.slice(0,10)+"..." : data?.id} ^FS `;

    //Packs
  let packs = `^FO 320, 170 ^A1, 25 ^FD PACKS(${data?.count}) ^FS `;
  
  // items
  let items = `^FO 20, 170 ^A1, 25 ^FD ITEMS(${data?.type == 'simple' ? '1' : data?.products?.length}) ^FS`;
  let divider = ``;

  let itemsRow1 = `^FO 20, 200 ^A1, 20 ^FD  Jollof rice2NGN300, Fish1NGN1,100  ^FS `;
  let itemsRow2 = `^FO 20, 230 ^A1, 20 ^FD  Eggs1NGN250, Spag1NGN100  ^FS `;
  let itemsRow3 = `^FO 20, 260 ^A1, 20 ^FD  Beaf2NGN500, Plantain5NGN100  ^FS `;
  let itemsRow4 = `^FO 20, 290 ^A1, 20 ^FD  Ogunfe2NGN1500, Eja Kika1NGN700  ^FS `;
  let itemsRow5 = ``;

  let itemsRow6 = `^FO 20, 200 ^A1, 20 ^FD  Jollof rice2NGN300, Fish1NGN1,100  ^FS `;
  let itemsRow7 = `^FO 20, 230 ^A1, 20 ^FD  Eggs1NGN250, Spag1NGN100  ^FS `;
  let itemsRow8 = `^FO 20, 260 ^A1, 20 ^FD  Beaf2NGN500, Plantain5NGN100  ^FS `;
  let itemsRow9 = `^FO 20, 290 ^A1, 20 ^FD  Ogunfe2NGN1500, Eja Kika1NGN700  ^FS `;
  let itemsRow10 = ``;
  let itemsRow11 = ``;

  itemsRow1 = ``;
  itemsRow2 = ``;
  itemsRow3 = ``;
  itemsRow4 = ``;
  itemsRow5 = ``;
  itemsRow6 = ``;
  itemsRow7 = ``;
  itemsRow8 = ``;
  itemsRow9 = ``;
  itemsRow10 = ``;
  itemsRow11 = ``;
 
  if(data?.products?.length > 0) {

    divider = `^FO280,210  ^GB 1,200,1 ^FS`;
    data?.products.forEach((element: any, i: number) => {
  
    
          if(i == 0) {
            itemsRow1 = itemsRow1 + ` ^FO 20, 220 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
             
          if(i == 1) {
            itemsRow2 = itemsRow2 + ` ^FO 20, 260 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
       
             
          if(i == 2) {
            itemsRow3 = itemsRow3 + ` ^FO 20, 300 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
       
             
          if(i == 3) {
            itemsRow4 = itemsRow4 + ` ^FO 20, 340 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
       
             
          if(i == 4) {
            itemsRow5 = itemsRow5 + ` ^FO 20, 375 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
       
             
          if(i == 5) {
            itemsRow6 = itemsRow6 + ` ^FO 290, 220 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
       
             
          if(i == 6) {
            itemsRow7 = itemsRow7 + ` ^FO 290, 260 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
       
             
          if(i == 7) {
            itemsRow8 = itemsRow8 + ` ^FO 290, 300 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
       
             
          if(i == 8) {
            itemsRow9 = itemsRow9 + ` ^FO  290, 340 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
          if(i == 9) {
            itemsRow10 = itemsRow10 + ` ^FO 290, 375 ^A0, 25 ^FD ${ element.name+"("+element.qty+")("+element.amount+")="+this.decimalPipe.transform(element.amount*element.qty, '.0') } ^FS`
          
          }
       
          if(i > 9) {

            itemsRow11 = ` ^FO 290, 400 ^A0, 25 ^FD more items..... ^FS` 

          }

       
  
    });

   
  }
  else {
   
    itemsRow1 = itemsRow1 + ` ^FO 65, 230 ^A0, 70  ^FD NGN${ this.decimalPipe.transform(data?.amount, '.1')} ^FS`
    packs = ``;
    orderId = ``;
    orderIdValue = ``;
    items = ``;

    // itemsRow2 = itemsRow2 + `^FO 20, 260 ^A0, 25 ^FD  1 ITEM  ^FS `;
    // itemsRow3 = `^FO 20, 300 ^A0, 25 ^FD - - -  ^FS `;
    // itemsRow4 = `^FO 20, 340 ^A0, 25 ^FD - - -  ^FS `;
  }




 //DIVIDER 



   //Total
  
   let total = ` ^FO 20,  440 ^A0, 30 ^FD TOTAL   ^FS`;
   let totalValue = `^FO 270, 440 ^A0, 35 ^FD  ${"NGN"+ this.decimalPipe.transform(data?.amount, '.1')} ^FS   `;

    //Tally
    let tally = ` ^FO 20, 560 ^A1, 25^FD TALLY: ^FS`;
    let tallyValue = `^FO 350, 560 ^A1, 25 ^FD  ${data?.tally} ^FS`;


    //Payment Type
    let paymenttype = `^FO 30, 600 ^A1, 25 ^FD PAYMENT METHOD:   ^FS`;
    let paymenttypeValue = `^FO 350, 600 ^A1, 25 ^FD  ${data?.payment_type} ^FS`;

     //Creator
     let creator = `^FO 30, 640 ^A1, 25 ^FD CREATOR: ^FS`;
     let creatorValue = `^FO 350, 640 ^A1, 25 ^FD  ${data?.creator?.length > 15 ?  data?.creator.slice(0,15)+"..." : data?.creator} ^FS  `;

      //Date Created

      // ^FO 20, 500 ^A0, 30 ^FD  DATE  01/04/2024 - TIME 2:45PM ^FS

      let date = `^FO 20, 500 ^A0, 30 ^FD  DATE  ${this.datePipe.transform( data?.created_at, 'dd/MM/yyyy')} - TIME ${this.datePipe.transform( data?.created_at, 'h:mm:ss  a' )} ^FS`;
      // let dateValue = `^FO 350, 580 ^A1, 20 ^FD  ${data?.created_at?.length > 10 ?  (this.datePipe.transform( data?.created_at, 'dd/MM/yyyy HH:mm:ss'))?.slice(0,10)+"..." : this.datePipe.transform( data?.created_at, 'yyyy/MM/dd HH:mm:ss')} ^FS `;

      //Thank You
      let thankyou = `^FO 150, 700 ^A0, 25 ^FD  Enjoy your meal! ^FS`;

      //QRCode
    
      let qrCode = `^FO 350, 640 ^BY4,2.0,50^BQN,2,2 ^FD ${data?.id} ^FS ^XZ  `;


      var zplCommand = 
      headingName+
      address+
      firstLine+
      orderId+
      orderIdValue+
      items+
      itemsRow1+
      itemsRow2+
      itemsRow3+
      itemsRow4+
      itemsRow5+

      itemsRow6+
      itemsRow7+
      itemsRow8+
      itemsRow9+
      itemsRow10+
      itemsRow11+

      packs+
      divider+
      seconLine+
      total+
      totalValue+
      thirdLine+
      tally+
      tallyValue+
      fourthLine+
      paymenttype+
      paymenttypeValue+
      creator+
      creatorValue+
      date+
      fifthLine+
      thankyou+
      qrCode;

      

      // var ipaddr: any = document.getElementById("zpl");
      // ipaddr.value = zplCommand


       if(this.who?.printertype == "1" ) {

        // Encode the String
       var encodedStringBtoA = btoa(zplCommand);
        this.printPing(encodedStringBtoA);
       }
       else if(this.who?.printertype == "2" ) {
        this.printDocument(modal, '', data) 
       }

       else if(this.who?.printertype == "3" ) {
        this.print(zplCommand);
       }
     
       else {
        alert("No vilid printer found or selected")

        return
       }
       
}



printPing(zplcmd: string) {

  this.api.pingPrint(
    {cmd: zplcmd,
    type: 'printer'
    }
    
    ).then((data: any) => {

    if(data?.success) {
      console.log("Printing Ping Successful")
    }
  })
}

   
print( zplcommand: string)
{
 
  var user = this.share.getUser();
  var ipaddr: any = document.getElementById("zpl");
  var zplcomand: any = zplcommand
  var ip: any = user?.ip

  var output: any = document.getElementById("output");
  var url = "http://"+ip+"/pstprnt";
  var method = "POST";
  var async = true;
  var request = new XMLHttpRequest();

  console.log(ip, zplcomand )


  request.onload =  () => {
    var status = request.status; // HTTP response status, e.g., 200 for "200 OK"
    var data = request.responseText; // Returned data, e.g., an HTML document.
    output.innerHTML = "Status: " + status + "<br>" + data;
  }

  request.open(method, url, async);
  request.setRequestHeader("Content-Length", zplcomand?.length);

  console.log(request)
  // Actually sends the request to the server.
  request.send(zplcomand);



}


deleteItem(item: any) {

  const index = this.button_data?.value.findIndex((elem: any) => elem?.name == item?.name );

  console.log(item)
  console.log(index)
  if (index > -1) { // only splice array when item is found
    this.button_data?.value.splice(index, 1); // 2nd parameter means remove one item only

     if(this.button_data?.value?.length <= 0)  {
        localStorage.removeItem('orders'); // remove local storage item if no items are left
        return
     }
    localStorage.setItem('orders', JSON.stringify(this.button_data?.value)); // save updated array to local storage
  }
}

}
